import { ActivityTypeModel } from '@/src/server/modules/activities/ActivityTypeModel'

export class ActivityTypesService {
  axios

  constructor ({ axios }) {
    this.axios = axios
  }

  async fetchActivityTypes (managerId) {
    const {
      data: {
        data: activityTypes,
      },
    } = await this.axios(
      `v2/managers/${managerId}/activitytypes`,
      {
        params: {
          'page[size]': 500,
        },
      }
    )

    return activityTypes.map(this.toActivityTypeModel)
  }

  toActivityTypeModel (activityType) {
    return new ActivityTypeModel({
      id: activityType.id,
      name: activityType.attributes.name,
    })
  }
}



// WEBPACK FOOTER //
// ./src/server/modules/activities/ActivityTypesService.js